'use client';

import Script from 'next/script';

export function HubSpotPixel() {
  return (
    <Script
      id="hs-script-loader"
      strategy="lazyOnload"
      src="https://js.hs-scripts.com/49022532.js"
    />
  );
}
